import { render, staticRenderFns } from "./VirtualKeyboard75.vue?vue&type=template&id=bfd5118e&scoped=true&"
import script from "./VirtualKeyboard75.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboard75.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboard75.vue?vue&type=style&index=0&id=bfd5118e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd5118e",
  null
  
)

export default component.exports